import React, { useState, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";
import { userLogin } from "../../services/MainApiDetails";
import { ERROR } from "../../utilities/colors";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SponsorSlider from "../../components/sponsorSlider/SponsorSlider";

const MobileLoginForm = () => {
  const [userName, setUserName] = useState();
  const [password, setPassword] = useState();
  const [errorPhone, setErrorPhone] = useState("");
  const [error, setError] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

const rotatingMessagesEn = [
  "Predict every match and stay ahead of the competition.",
  "Compete with football fans and conquer the leaderboard.",
  "Turn your predictions into exciting daily, weekly, and mega prizes.",
];

const rotatingMessagesMl = [
  "ഓരോ മാച്ചും പ്രവചിച്ച് മത്സരത്തിൽ മുന്നിലെത്തൂ.",
  "ഫുട്ബോൾ ആരാധകർക്കൊപ്പം മത്സരിച്ച് ലീഡർബോർഡ് കീഴടക്കൂ.",
  "നിങ്ങളുടെ പ്രവചനങ്ങൾ ദിവസേനയും ആഴ്ചയിലുമുള്ള മെഗാ സമ്മാനങ്ങളാക്കി മാറ്റൂ.",
];

const rotatingMessages =
  localStorage.language === "en" ? rotatingMessagesEn : rotatingMessagesMl;

  const [messageIndex, setMessageIndex] = useState(0);
  const [fadeIn, setFadeIn] = useState(true);
  const navigate = useNavigate();

  function submitLogin() {
    if (!userName) {
      setErrorPhone("Please enter email/phone");
    } else if (!password) {
      errorPassword("Please enter password");
    } else {
      if (userName) {
        let data = 1;
        let filter = /^\d*(?:\.\d{1,2})?$/;
        let testEmail = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i;
        if (testEmail.test(userName)) {
          data = {
            phone: userName.toLowerCase(),
            password: password,
          };
        } else if (filter.test(userName)) {
          data = {
            phone: userName,
            password: password,
          };
        }

        if (data != 1) {
          setErrorPhone("");
          userLogin(data)
            .then((res) => {
              if (res.data.status) {
                localStorage.setItem("webKey", res.data.web_token);
                localStorage.setItem("webKey", res.data.web_token);
                localStorage.setItem("webKey", res.data.web_token);
                localStorage.setItem("webKey", res.data.web_token);
                localStorage.setItem("webKey", res.data.web_token);
                if (res.data.web_token) {
                  navigate("/mobile-winners");
                }
              } else {
                setError(res.data.message);
              }
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          setErrorPhone("Please enter valid email/phone");
        }
      }
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeIn(false); // start fade-out

      setTimeout(() => {
        setMessageIndex((prev) => (prev + 1) % rotatingMessages.length);
        setFadeIn(true);
      }, 400);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="mobileLogin-form-top">
        <p>Save and track your predictions</p>
      </div>
      <div className="mobileLogin-form-middle">
        <form action="">
          <div className="mobileLogin-input-wrapper">
            <div className="mobileLogin-inputBox">
              <span>Email / Mobile</span>
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <input
                  type="text"
                  placeholder="Type here"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  style={{ width: '100%', paddingRight: '40px' }}
                />
                <span style={{
                  position: 'absolute', right: '10px', display: 'flex',
                  alignItems: 'center', justifyContent: 'center', height: '100%', top: 0,
                }}>
                  <PersonOutlineIcon fontSize="small" />
                </span>
              </div>
              <span style={{ color: ERROR }}>{errorPhone}</span>
            </div>

            <div className="mobileLogin-inputBox">
              <span>Password</span>
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Type here"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ width: '100%', paddingRight: '40px' }}
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    top: 0,
                  }}>
                  {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                </span>
              </div>
              <span style={{ color: ERROR }}>{errorPassword}</span>
            </div>
          </div>
          <span style={{ color: ERROR }}>{error}</span>

          <div className="mobileLogin-signup-button">
            <button
              className="login-btn"
              type="button"
              onClick={submitLogin}
            >
              LOGIN
            </button>
          </div>
        </form>
        <div className="mobileLogin-forgot">
          <p className="forgot-btn">
            <Link to="/mobile-forgot-password">Forgot password?</Link>
          </p>
        </div>
      </div>
      <div className="mobileLogin-form-bottom">
        <div className="mobileLogin-bottomBanner-wrapper">
          <div className="top">
            <div className="mobileLogin-info-icon">
              <EmojiEventsIcon fontSize="small" style={{ color: "var(--color-white)" }} />
            </div>
            <p className={`mobileLogin-rotating-text ${fadeIn ? "fade-in" : "fade-out"}`}>
              {rotatingMessages[messageIndex]}
            </p>
          </div>
          <div className="mobileLogin-banner-dots">
            {rotatingMessages.map((_, idx) => (
              <span
                key={idx}
                className={`banner-dot ${idx === messageIndex ? "active" : ""}`}
              />
            ))}
          </div>
        </div>
        <div className="mobileLogin-sponsor-bottom">
          <SponsorSlider />
        </div>
      </div>
    </>
  );
};

export default MobileLoginForm;